// extracted by mini-css-extract-plugin
export default {"container":"bst-set-and-mobile-already-in-use-popup_container__RB3Gb","btn-container":"bst-set-and-mobile-already-in-use-popup_btn-container__JH15-"};